var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8285 0.171648C19.6627 0.00586637 19.414 -0.0451103 19.1965 0.0419211L0.368341 7.5731C0.152911 7.65928 0.00865307 7.86443 0.000371811 8.09635C-0.00787039 8.32822 0.121505 8.54311 0.330255 8.64436L7.7548 12.2452L11.3557 19.6697C11.4539 19.8722 11.6589 20 11.8827 20C11.8897 20 11.8967 19.9999 11.9037 19.9996C12.1355 19.9914 12.3407 19.8471 12.4269 19.6317L19.9581 0.803602C20.0452 0.585945 19.9942 0.33739 19.8285 0.171648ZM2.03491 8.16865L16.9813 2.19017L8.07386 11.0975L2.03491 8.16865ZM11.8314 17.9651L8.9025 11.9261L17.8099 3.01876L11.8314 17.9651Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.68a7d0e51406933970058988a4799410.svg";
export { ForwardRef as ReactComponent };